import React from 'react'
import { Paragraph } from 'theme-ui'
import { FAQItem } from 'components/FrequentlyAskedQuestions'
import { CONTROLDText } from 'ui/CONTROLD'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLink'

export const frequentlyAskedQuestions: FAQItem[] = [
  {
    question: `How does ${CONTROLDText} block inappropriate content?`,
    answer: (
      <Paragraph>
        We use <StyledLink to="/features/web-filtering/">AI-driven filtering</StyledLink> and
        real-time threat intelligence to <strong>automatically block harmful websites</strong> and
        enforce <strong>Safe Search</strong>.
      </Paragraph>
    ),
  },
  {
    question: `Is ${CONTROLDText} compliant with CIPA?`,
    answer: (
      <Paragraph>
        Yes! {CONTROLDText} helps schools in the U.S. comply with{' '}
        <StyledLink to="/blog/what-is-cipa/">CIPA</StyledLink> regulations and meet{' '}
        <strong>KCSIE requirements</strong> in the UK.
      </Paragraph>
    ),
  },
  {
    question: 'Can we set different filtering rules for different grade levels?',
    answer: (
      <Paragraph>
        Absolutely! {CONTROLDText} allows you to{' '}
        <strong>apply unique filtering policies for different student groups</strong>, ensuring
        age-appropriate internet access.
      </Paragraph>
    ),
  },
  {
    question: `Does this work on school-issued Chromebooks?`,
    answer: (
      <Paragraph>
        Yes! {CONTROLDText} integrates with{' '}
        <strong>Chromebooks, Windows, Mac, iPads, and mobile devices</strong>.
      </Paragraph>
    ),
  },
  {
    question: `Can we see internet activity reports for students?`,
    answer: (
      <Paragraph>
        Yes! The <strong>{CONTROLDText} dashboard provides real-time insights</strong> into blocked
        sites, browsing patterns, and security alerts.
      </Paragraph>
    ),
  },
]
